export default class ApiError {
	status: number
	message: any
	body: any
	data: any
	userMessage: string

	constructor(status: number, message: string) {
		this.status = status
		this.message = message
		this.body = null
		this.data = null
		this.userMessage = message

		try {
			this.body = JSON.parse(message)
			this.data = this.body?.data ?? null
			this.userMessage = this.body?.message || this.body?.error?.message || message
		} catch {
			this.body = null
			this.data = null
			this.userMessage = message
		}
	}

	toString() {
		return this.userMessage
	}
}
